import toast from 'react-hot-toast';
import { captureException } from '@sentry/react';
import { getDisplayError } from '../../../utils/get-display-error';

interface UploadedDocument {
  id: string;
  name: string;
  hash: string;
}

export async function uploadClaimDocuments(files: globalThis.File[]): Promise<UploadedDocument[]> {
  const uploadPromises = files.map(async (file) => {
    const formData = new FormData();
    formData.set('name', file.name);
    formData.set('file', file);

    const result = await fetch('/api/document/upload', {
      body: formData,
      method: 'post',
    });

    const text = await result.text();
    if (!result.ok) {
      throw new Error('Upload mislukt');
    }

    return JSON.parse(text).data as UploadedDocument;
  });

  const results = await Promise.allSettled(uploadPromises);
  const successfulDocs: UploadedDocument[] = [];
  const failedCount = results.filter((r) => r.status === 'rejected').length;

  for (const result of results) {
    if (result.status === 'fulfilled') {
      successfulDocs.push(result.value);
    }
  }

  if (successfulDocs.length === 0 && failedCount > 0) {
    throw new Error('Upload mislukt');
  }

  if (failedCount > 0) {
    toast.error(`${failedCount} bestand(en) konden niet worden geüpload`);
  }

  return successfulDocs;
}

export function handleClaimDocumentUpload(
  files: globalThis.File[],
  currentAttachments: UploadedDocument[],
  setFieldValue: (field: string, value: any) => void,
) {
  uploadClaimDocuments(files)
    .then((uploadedDocs) => {
      setFieldValue('attachments', [...currentAttachments, ...uploadedDocs]);
      toast.success(`${uploadedDocs.length} bestand(en) geüpload`);
    })
    .catch((err) => {
      captureException(err);
      toast.error('Kon bijlagen niet uploaden: ' + getDisplayError(err));
    });
}
